/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Intensivecourseschoosen2Inputs */

const de__field_intensivecourseschoosen2 = /** @type {(inputs: _Field_Intensivecourseschoosen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crashkurse (mehrtägig)`)
};

/**

* @param {_Field_Intensivecourseschoosen2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_intensivecourseschoosen2 = /** @type {((inputs?: _Field_Intensivecourseschoosen2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Intensivecourseschoosen2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_intensivecourseschoosen2(inputs)
});
export { _field_intensivecourseschoosen2 as "_field_intensiveCoursesChoosen" }